import { RootState } from "../types";

export const getRootPlaceSelector = (state: RootState) => state.place